import Spinner from '@/generic-components/Spinner';
import { fetchBasket } from '@/hooks/helperFunctions';
import { IBasket } from '@/types/simo/basket';
import { getSessionStorage } from '@/utils/session';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { basket as basketurl } from '@/api/urls';
import GoBack from '@/generic-components/goBack';
import MiniBasket from '@/components/simo/checkout/miniBasket';
import { CheckoutAccordion } from '@/components/simo/checkout/accordion';
import CheckoutWrapper from '@/modules/checkout-wrapper';
import { fetchCheckoutCms } from '@/contentful/entries';
import { detectSuccessfulPaymentURL } from '@/utils/helper';

const Checkout = () => {
  const [basket, setBasket] = useState<IBasket | any>();
  const [checkoutCms, setCheckoutCms] = useState<IBasket | any>();
  const [isCmsLoading, setIsCmsLoading] = useState<boolean>(true);

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const session = getSessionStorage('_session');
  const history = useHistory();

  useEffect(() => {
    const isBasket = async () => {
      const response = await fetchBasket(session);
      if (response?.responseCode === 404) {
        setIsLoading(false);
      }
      setBasket(response?.basket);
      setIsLoading(false);
    };
    const fetchFromCms = async () => {
      try {
        await fetchCheckoutCms(setCheckoutCms);
        setIsCmsLoading(false);
      } catch (error) {
        console.error(error);
      }
    };

    fetchFromCms();

    //For some stupid reason, we can't call a basket after dibs...
    if (!detectSuccessfulPaymentURL(window.location)) {
      isBasket();
    }

    if (detectSuccessfulPaymentURL(window.location)) {
      setIsLoading(false);
    }
  }, []);

  const goToBasket = () => {
    const basketUrl = basketurl.url({
      state: {
        session
      }
    });
    history.push(basketUrl);
  };
  const ecProducts =
    basket &&
    basket?.priceSummaries[0]?.recurring?.map((product: any) => {
      return {
        name: product.name,
        category: 'subscription',
        spc_productcode: product.basisSubscriptionProductCode,
        price: product.price,
        quantity: 1
      };
    });

  return (
      <>
        <CheckoutWrapper>
          <title>checkout</title>
          <meta property="description" content="checkout" />
          {isLoading || isCmsLoading ? (
            <Spinner />
          ) : (
            <>
              <GoBack goBack={() => goToBasket()} />
              <div className="ys-container-fluid">
                <div className="ys-row mb-3">
                  <div className="ys-col-lg-8 ys-col-12 ys-offset-lg-2">
                    <MiniBasket basket={basket} goToBasket={goToBasket} />
                    <CheckoutAccordion
                      basket={basket}
                      setBasket={setBasket}
                      checkoutCms={checkoutCms}
                      ecProducts={ecProducts}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </CheckoutWrapper>
      </>
  );
};

export default Checkout;
